<script>
import { mapGetters } from 'vuex';
import { REPLY_EDITOR_MODES } from 'dashboard/components/widgets/WootWriter/constants';

import Message from './Message.vue';
import WhatsappRestrictionMessage from './WhatsappRestrictionMessage.vue';
import WidgetConversationContactOfflineMessage from './WidgetConversationContactOfflineMessage.vue';

import inboxMixin from 'shared/mixins/inboxMixin';
import mixin from './mixin';

export default {
  components: {
    Message,
    WhatsappRestrictionMessage,
    WidgetConversationContactOfflineMessage,
  },
  mixins: [inboxMixin, mixin],
  emits: ['selectWhatsappTemplate'],
  data() {
    return { replyType: REPLY_EDITOR_MODES.REPLY };
  },
  computed: {
    ...mapGetters({ currentChat: 'getSelectedChat' }),
    currentContact() {
      return this.$store.getters['contacts/getContact'](
        this.currentChat.meta.sender.id
      );
    },
    inboxId() {
      return this.currentChat.inbox_id;
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.inboxId);
    },
  },
  watch: {
    currentChat(conversation) {
      const { can_reply: canReply } = conversation;

      if (canReply || this.isAWhatsAppChannel) {
        this.replyType = REPLY_EDITOR_MODES.REPLY;
      } else {
        this.replyType = REPLY_EDITOR_MODES.NOTE;
      }
    },
  },
};
</script>

<template>
  <div
    class="relative py-0 px-4 border-t border-solid border-[var(--color-border)] -mt-[1px] min-h-[6.25rem] flex justify-center items-center text-center"
  >
    <Message v-if="!isConversationOpen" class="p-5">
      Abra a conversa para habilitar o envio de mensagens.
    </Message>
    <WhatsappRestrictionMessage
      v-else-if="isWhatsappRestricted"
      @select-whatsapp-template="$emit('selectWhatsappTemplate')"
    />
    <WidgetConversationContactOfflineMessage
      v-else-if="isWidgetInboxConversationAndCurrentContactOffline"
    />
  </div>
</template>
